import { Component, Vue } from 'vue-property-decorator'
import '../lib/bootstrap/scss/bootstrap.scss'
import 'vue-multiselect/dist/vue-multiselect.min.css'

@Component

export default class App extends Vue {

	private defaultTemplate: string = 'default';

	private get Template () {

		return (this.$route.meta.template || this.defaultTemplate) + '-template';
	}
}
